<template>
    <div :style="{'background':is_moderator_view?'#2a2a2a':'transparent'}" style="width:100%;height:100%;">
      <v-progress-linear
          v-show="show_video && !is_moderator_view"
          :value="(duration_played/duration)*100"
          color="blue"
          height="50"
          striped
      >
        <template v-slot:default="">
          <strong style="font-size:25px;letter-spacing: 4px;" class="shadowed"><span>{{donation_sender}}</span> {{donation_amount}}{{is_bits?' bits':' kr'}}</strong>
        </template>
      </v-progress-linear>
        <youtube @ended="ended" :style="{'opacity':opacity}"  @cued="ready_to_play" ref="youtube" v-show="show_video"  style="width:100%;height:100%;pointer-events: none;" :player-vars="playerVars"></youtube>
      <v-card
          class="mx-auto"
          max-width="500"
          height="600"
          style="top:100px;"
          v-if="is_moderator_view"
          dark
      >
        <v-toolbar
            color="pink"
            dark
        >

          <v-toolbar-title>Video Alerts Mod</v-toolbar-title>

          <v-spacer></v-spacer>


        </v-toolbar>

        <v-list dark two-line>

            <template v-for="(video, index) in approve_list">
              <v-list-item :key="video.title">
                  <v-list-item-content>
                    <v-list-item-title style="font-size:20px;white-space: nowrap;display:flex;" >{{video.sender}} <span style="color:gray;margin-left:4px;">{{video.amount}} kr</span> <v-spacer></v-spacer><small style="color:gray;">{{video.time}}</small></v-list-item-title>


                    <v-list-item-title><a target="_blank" :href="'https://youtube.com/watch?v='+video.id">{{"youtube.com/watch?v="+video.id}}</a></v-list-item-title>
                  </v-list-item-content>

                  <v-list-item-action>
                    <v-btn @click="approve_video(video.id,video.transaction_id)" icon>
                      <v-icon color="green">mdi-check-bold</v-icon>
                    </v-btn>
                    <v-btn icon>
                      <v-icon color="red" @click="remove_video(video.id,video.transaction_id)">mdi-close</v-icon>
                    </v-btn>
                  </v-list-item-action>


              </v-list-item>

              <v-divider
                  dark
                  v-if="index < approve_list.length - 1"
                  :key="index"
              ></v-divider>
            </template>
        </v-list>
      </v-card>

    </div>
</template>

<script>
    export default {
        name: "VideoWidget",
        data() {
            return {
              player_volume:1,
              is_bits:false,
              to_be_approved:{

              },
              approve_list:[],
              require_moderator:false,
              is_moderator_view:false,
              donation_sender:"",
              donation_amount:0,
              videoId: '',
              duration_interval:null,
              id:"",
              duration_played:0,
                playerVars:{
                    autoplay: 0,
                    controls: 0,
                    start:0,
                    fs:0,
                    iv_load_policy:3,
                    enablejsapi:1,
                    modestbranding:1


                },
                duration:10,
                opacity:1,
                show_video:false,
                queue:[],
                sid:0
            }
        },
      computed:{
        player() {
          return this.$refs.youtube.player
        }
      },
        mounted:function(){
            this.id=this.$route.query.id;
            this.is_moderator_view=this.$route.query.mod==="1";
            this.get_overlay_info();


        },



        methods: {

          approve_video(video_id,transaction_id){
            this.$socket.emit("approve_video",{
              video_id:video_id,
              hash:this.id,
              transaction_id:transaction_id
            })


          },
          remove_video(video_id,transaction_id){
            this.$socket.emit("remove_video",{
              video_id:video_id,
              hash:this.id,
              transaction_id:transaction_id
            })

          },

          get_overlay_info:function(){
            let http = new XMLHttpRequest();
            let url = '/api/overlay_info?hash='+this.id;
            http.open('GET', url, true);
            let self=this;
            http.setRequestHeader('Content-type', 'application/x-www-form-urlencoded');

            http.onreadystatechange = function() {

              if(http.readyState === 4 && http.status === 200){
                let resp=JSON.parse(http.responseText);
                let setup=JSON.parse(resp.SETUP)
                self.require_moderator=setup.view_limit===3;
                if("bits" in resp){
                  self.is_bits=true;
                }
                if("volume" in setup){
                  self.player_volume=setup.volume;

                }
                self.$socket.emit('video_alert_greeting', self.id);


              }

            };
            http.send();
          },

          ended:function(){
            this.show_video=false;
          },

          ready_to_play:function(){
            this.playVideo();

          },
            async playVideo() {
              clearInterval(this.duration_interval)
              let player=await this.player;
              this.show_video=true;
              let self=this;
              //this.duration_played=0.05;
              let intervals=this.duration/0.2;
              for(let i=0;i<intervals;i++){
                setTimeout(function(){
                  self.duration_played+=0.2;

                },i*200)
              }

              player.setVolume(this.player_volume);
              player.playVideo()
              setTimeout(function(){
                player.pauseVideo();
                clearInterval(self.duration_interval)
                self.show_video=false;
                self.queue=self.queue.slice(1)


              },((this.duration)*1000)+800);
              // Do something after the playVideo command
            },
            async handle_video(data){
              let player=  await this.player.playVideo()
              this.donation_sender=data.sender;
              this.donation_amount=data.amount;
              let videoInfo=data;
              try{
                player.pauseVideo();
                let duration=parseInt(videoInfo.duration);
                this.duration=duration;
                this.duration_played=0;
                console.log(duration);
                this.opacity=videoInfo.opacity/100;
                player.cueVideoById({videoId:videoInfo.id,
                  startSeconds:parseInt(videoInfo.start),
                  endSeconds:parseInt(videoInfo.start)+duration});



              }
              catch(e){
                console.log(e);
                //console.log("No video")
              }
            }

        },

        sockets: {

          setup:function(data){
            let self=this;
            try{
              let setup=JSON.parse(data)
              self.require_moderator=setup.view_limit===3;

              if("volume" in setup){
                self.player_volume=setup.volume;
                if(self.$refs.youtube.player){
                  self.$refs.youtube.player.setVolume(self.player_volume);
                }
              }


            }catch{
              console.log("setup error")
            }



          },

            video_approved(data){
              if(data.transaction_id in this.to_be_approved && !this.is_moderator_view){
                let video_data=this.to_be_approved[data.transaction_id];
                delete this.to_be_approved[data.transaction_id];

                if(this.queue.length===0){
                  this.handle_video(video_data);
                  this.queue.push(video_data);
                }
                else{
                  this.queue.push(video_data);
                }
              }else if(this.is_moderator_view){
                this.approve_list= this.approve_list.filter(video=> video.transaction_id!==data.transaction_id);
                document.title = "PENDING: "+this.approve_list.length;


              }
            },
            video_removed(data){
              if(data.transaction_id in this.to_be_approved && !this.is_moderator_view){
                delete this.to_be_approved[data.transaction_id];

              }else if(this.is_moderator_view){
                this.approve_list= this.approve_list.filter(video=> video.transaction_id!==data.transaction_id);
                document.title = "PENDING: "+this.approve_list.length;


              }
            },

            play_video(data){
              if(!this.require_moderator && !this.is_moderator_view){
                if(this.queue.length===0){
                  this.handle_video(data);
                  this.queue.push(data);
                }
                else{
                  this.queue.push(data);
                }
              }else if(!this.is_moderator_view){
                this.to_be_approved[data.transaction_id]=data;
              }else{
                var today = new Date();
                var time = today.getHours() + ":" + today.getMinutes();
                data.time=time;
                this.approve_list.push(data);
                document.title = "PENDING: "+this.approve_list.length;

              }

            },

          connected(data) {
                try{
                    let data_p=JSON.parse(data);
                    console.log(data);
                    console.log("CONNECTED")
                    this.sid=data_p.SID;

                }
                catch{
                    console.log("error parsing setup data")
                }
            }},
        watch:{
            queue:function(newQ,oldQ){
                if(newQ.length<oldQ.length && newQ.length>0){
                    this.handle_video(this.queue[0])
                }
            }
        }
    }
</script>

<style>

  .shadowed{
    color: rgb(255 255 255);
    text-shadow: 2px 2px 2px black;
  }
    iframe{
        width:100% !important;
        height:100% !important;
    }
    ::-webkit-scrollbar {
        width: 0 !important;
    }

    /* Track */
    ::-webkit-scrollbar-track {
        background: transparent !important;
    }

    /* Handle */
    ::-webkit-scrollbar-thumb {
        background: transparent !important;
    }

    /* Handle on hover */
    ::-webkit-scrollbar-thumb:hover {
        background:transparent !important;
    }


</style>
